import { put, call, spawn } from 'redux-saga/effects'
import { applyProjectsAction, expandProjectAction } from 'actions/projectActions'
import getProjectsAndSettings from 'sagas/setupProjectsSaga/getProjectsAndSettings'
import handleOfflineProject from 'sagas/setupProjectsSaga/handleOfflineProject'
import { createSignedInManufacturerSpecificProject } from 'sagas/setupProjectsSaga/handleManufacturerSpecificProject'
import createDocumentSaga from 'sagas/createDocumentSaga'
import deferApplyProjects from 'sagas/setupProjectsSaga/deferApplyProjects'

export default function * handleSpecificManufacturer({ offline, active, manufacturer }) {
  if (offline) {
    yield call(handleOfflineProject, { manufacturer, active })
  } else {
    const { settings } = yield call(getProjectsAndSettings)
    const project = yield call(createSignedInManufacturerSpecificProject, manufacturer)
    yield spawn(deferApplyProjects, project._id)
    yield call(createDocumentSaga, project)
    yield put(applyProjectsAction([project]))
    yield put(expandProjectAction(project, false, active, false, settings))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/handleManufacturerSpecificSetup.js